export const dashboardPath = () => '/documents';
